
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTiktokBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 29,
  viewBox: "0 0 26 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.333 7.569c-2.139.095-6.533-1.086-7-6.569H13.25v15.993c0 4.57-3.598 6.525-5.995 4.79-3.044-2.205-1.005-6.79 2.787-6.218V10.71C7.125 10.71 1 11.852 1 18.992c0 9.139 9.938 8.853 12.25 7.649 3.762-1.96 4.667-4.083 4.667-8.791V9.853c.972.476 3.616 1.485 6.416 1.714",
  stroke: "#000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"26\" height=\"29\" viewBox=\"0 0 26 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M24.3333 7.56854C22.1944 7.66374 17.8 6.4833 17.3333 1H13.25V16.993C13.25 21.5624 9.6516 23.5184 7.25479 21.7823C4.2108 19.5776 6.25004 14.9939 10.0417 15.565V10.71C7.12504 10.71 1 11.8523 1 18.992C1 28.131 10.938 27.8454 13.25 26.641C17.0122 24.6811 17.9167 22.5581 17.9167 17.8497C17.9167 13.5659 17.9167 10.9956 17.9167 9.85325C18.8889 10.3292 21.5333 11.3383 24.3333 11.5668\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/tiktok-black.4165d7e2f94fc611a3d3a6f840910617.svg"),
        {
          React: SvgTiktokBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      